import type { ProposalListItem, ProposalType } from '@cdf/api-client-react';
import { humanize, tenderStatusLabels } from './tender-presentation';

export const proposalTypeLabels: Record<ProposalType, string> = { tender: 'Tender', sow: 'SOW' };
export const proposalStatusLabels: Record<string, string> = {
  ...tenderStatusLabels, published: 'Published', needs_update: 'Needs update'
};

export function proposalDestination(proposal: ProposalListItem) {
  return proposal.source === 'managed_sow' ? `/files/${proposal.id}` : `/manage/tenders/${proposal.id}`;
}

export function proposalStatusLabel(status: string) {
  return proposalStatusLabels[status] ?? humanize(status);
}
